import * as React from "react";
import { Maximize, Eye, Users, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
const rooms = [{
  id: "slot-machines",
  title: "Refurbished Slot Machines",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660634/img/atlantis_slot_machines.png",
  sqm: "Global Sales",
  view: "Certified Quality",
  occupancy: "B2B Solutions",
  link: "/HomePage"
}, {
  id: "management-systems",
  title: "Casino Management Systems",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660634/img/atlantis_casino_management.png",
  sqm: "Real-time Data",
  view: "Secure UI",
  occupancy: "Full Control",
  link: "/HomePage"
}, {
  id: "technical-support",
  title: "Technical Installation Support",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660634/img/atlantis_technical_support.png",
  sqm: "Expert Team",
  view: "On-site Service",
  occupancy: "24/7 Support",
  link: "/HomePage"
}, {
  id: "live-equipment",
  title: "Live Gambling Equipment",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660634/img/atlantis_live_equipment.png",
  sqm: "Premium Tables",
  view: "Live Gaming",
  occupancy: "Global Delivery",
  link: "/HomePage"
}, {
  id: "content-development",
  title: "Slot & Online Content",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660634/img/atlantis_game_dev.png",
  sqm: "Custom Games",
  view: "HTML5 Ready",
  occupancy: "Creative Studio",
  link: "/HomePage"
}, {
  id: "studio-systems",
  title: "Live Studio Systems",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660634/img/atlantis_studio_systems.png",
  sqm: "Broadcast Tech",
  view: "Turnkey Setup",
  occupancy: "High-End Gear",
  link: "/HomePage"
}];
export default function ArtisanSanctuaries() {
  return <section data-section-id="222071" id="our-technological-solutions" className="bg-gradient-to-r from-[#007bff] to-[#0056b3] py-24 px-4 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-7xl">
        <div className="mb-16 text-center">
          <h2 className="font-default text-4xl font-bold tracking-widest text-white uppercase sm:text-5xl">
            We Offer The Following Solutions And Services
          </h2>
          <p className="mt-4 text-lg text-white/90 max-w-2xl mx-auto font-default">
            Innovative technology solutions and extensive casino equipment on a global level.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
          {rooms.map((room, i) => <div key={room.id} data-index={i} className="group flex flex-col overflow-hidden rounded-xl bg-white shadow-lg transition-all duration-500 hover:shadow-2xl hover:-translate-y-2.5">
              <div className="relative aspect-[4/3] w-full overflow-hidden">
                <img src={room.image} alt={room.title} className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-110" />
              </div>
              
              <div className="flex flex-1 flex-col justify-between p-6">
                <div>
                  <h3 className="font-default text-lg font-bold text-black mb-4">
                    {room.title}
                  </h3>
                  
                  <ul className="mb-8 flex flex-wrap items-center gap-x-6 gap-y-2 text-sm text-slate-600 font-default">
                    <li className="flex items-center gap-2">
                      <Maximize className="h-4 w-4 text-[#007BFF]" />
                      <span>{room.sqm}</span>
                    </li>
                    <li className="flex items-center gap-2">
                      <Eye className="h-4 w-4 text-[#007BFF]" />
                      <span>{room.view}</span>
                    </li>
                    <li className="flex items-center gap-2">
                      <Users className="h-4 w-4 text-[#007BFF]" />
                      <span>{room.occupancy}</span>
                    </li>
                  </ul>
                </div>

                <div className="mt-auto pt-4 border-t border-slate-100">
                  <Link to={room.link} className="group/link relative inline-flex w-fit items-center gap-2 pb-1 text-sm font-bold tracking-wide text-[#0C71C3] transition-colors hover:text-[#007BFF]">
                    Learn More
                    <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover/link:translate-x-1" />
                    <span className="absolute bottom-0 left-0 h-[1px] w-full origin-bottom-right scale-x-0 bg-current transition-transform duration-300 ease-out group-hover/link:origin-bottom-left group-hover/link:scale-x-100" />
                  </Link>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}